import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useCancelContractLinks = () => {
  const { i18n } = useTranslation();

  const links: Record<string, string> = useMemo(() => {
    try {
      return JSON.parse(process.env.REACT_APP_CANCEL_CONTRACT_LINKS || "{}");
    } catch {
      console.error(
        "Invalid links configuration provided, make sure that REACT_APP_CANCEL_CONTRACT_LINKS is a valid JSON string."
      );
      return {};
    }
  }, []);

  const result = links[i18n.language as keyof typeof links];

  if (!result) {
    console.error(
      `No links configuration found for language ${i18n.language}, falling back to en.`
    );
    return links.en || "";
  }

  return result;
};
